import {ChangeDetectorRef, Component, ElementRef, Input} from "@angular/core";
import {FUIAbstractPop, PopParentHorizontalAlignment, PopParentVerticalAlignment} from "../../../../pops/abstract-pop";
import {FUIPopsService} from "../../../../pops/pops.service";
import {FUIResponsiveService} from "../../../../page/responsive.service";
import {FUIEventsService} from "../../../../events/events.service";

@Component({
    selector: "fui-validation-pop",
    styleUrls: ["./validation-pop.component.scss"],
    templateUrl: "./validation-pop.component.html"
})
export class FUIValidationPopComponent extends FUIAbstractPop {
    parentHorizontalAlignment: PopParentHorizontalAlignment = PopParentHorizontalAlignment.RIGHT;
    @Input() public parentVerticalAlignment: PopParentVerticalAlignment = PopParentVerticalAlignment.ABOVE;
    limitWidthToParent: boolean = false;
    adjustHeightToFirstElement: boolean = false;
    override exclusive: boolean = false;

    constructor(changeDetectorRef: ChangeDetectorRef,
                elementRef: ElementRef,
                eventsService: FUIEventsService,
                popsService: FUIPopsService,
                responsiveService: FUIResponsiveService) {
        super(changeDetectorRef, elementRef, eventsService, popsService, responsiveService);
    }
}
